<template>
 <on-click-outside :do="hideBox">
  <div ref="selector" class="flex flex-col selector-city relative rounded border-grey-lighter w-40">
    <div v-if="!is_city" class="font-bold flex flex-row justify-between text-brand-light"
      @click.stop="showBox = !showBox">
      <div v-html="displayValue"></div>
      <img class="ml-5 mr-1 cursor-pointer" src="@/assets/SVG/arrow_down.svg" />
    </div>
    <div v-if="is_city" class="font-bold flex flex-row justify-center text-brand-light ">
      <img class="md:mr-3 mr-1 ml-auto  w-3 h-3 md:w-auto md:h-auto" style="transform: scale(1.1);" src="@/assets/SVG/area.svg" />
      <div class="cursor-pointer" @click.stop="!cityIsOnlyOne ? showBox = !showBox :null" v-html="displayValue"></div>
    </div>
    <div ref="showBox"
      class="bg-white listBox items-center absolute z-30 shadow-lg rounded-lg"
      v-show="showBox">
      <div class="w-full py-2 flex flex-row px-5 text-base font-normal text-left cursor-pointer select-none selectedLabel"
        :key="listItem.id" v-for="(listItem, key) in sortedOptions"
        @click="selectListItemClick(key); $emit('itemSelected')">
        <div class="">{{listItem.name}}</div>
      </div>
    </div>
  </div>
 </on-click-outside>
</template>

<script>
import Popper from 'popper.js';
import OnClickOutside from '../OnClickOutside';

export default {
  components: { OnClickOutside },
  name: 'citySelectbox',
  props: {
    listItems: Object,
    is_city: {
      type: Boolean,
      default: false,
    },
    value: [Number, String],
    placeholder: String,
    cityIsOnlyOne: false,
    sortType: {
      type: String,
      default: 'abc',
    },
  },
  data() {
    return {
      showBox: false,
    };
  },
  watch: {
    showBox() {
      if (this.showBox) {
        // this.setupPopper();
        document.addEventListener('click', this.hideSelectboxHandler);
      } else {
        document.removeEventListener('click', this.hideSelectboxHandler);
      }
    },
  },
  created() {
    this.hideSelectboxHandler = () => {
      this.hideBox();
    };
  },
  beforeDestroy() {
    if (this.popper) {
      this.popper.destroy();
    }
  },
  methods: {
    // setupPopper() {
    //   if (this.popper === undefined) {
    //     this.popper = new Popper(this.$refs.selector, this.$refs.showBox, {
    //       placement: 'left-end',
    //     });
    //   } else {
    //     this.popper.scheduleUpdate();
    //   }
    // },
    selectListItemClick(key) {
      let tempKey = key;
      if (this.$route.name === 'partners.events.draft') {
        this.$router.push({ name: 'events' });
      }
      if (this.sortType) {
        Object.keys(this.listItems).forEach((item, idx) => {
          if (this.listItems[item].id === this.sortedOptions[key].id) {
            tempKey = this.listItems[item].id;
          }
        });
      }
      if (this.listItems[tempKey].disabled) return;
      this.showBox = false;
      this.$emit('hideTeamCreate');
      this.$emit('input', tempKey);
    },
    hideBox() {
      this.showBox = false;
    },
  },
  computed: {
    displayValue() {
      return this.listItems[this.value] ? this.listItems[this.value].name : this.placeholder;
    },
    sortedOptions() {
      if (this.sortType) {
        const templateObj = {};

        Object.keys(this.listItems).sort((itemA, itemB) => {
          if (this.sortType === 'id') {
            return this.listItems[itemA].id > this.listItems[itemB].id ? 1 : -1;
          } else if (this.sortType === 'abc') {
            return this.listItems[itemA].name > this.listItems[itemB].name ? 1 : -1;
          }
        }).forEach((item, index) => templateObj[index] = this.listItems[item]);
        return templateObj;
      }
      return this.listItems;
    },
  },
};
</script>

<style scoped lang="less">
.selector-city{

}
.listBox {
  width: 300px;
  height: 185px;
  overflow-y: scroll;
  border: 1px solid #979797;
  right: 0;
  top: 140%;
}
::-webkit-scrollbar {
  width: 8px;
  height: 4px;

}
::-webkit-scrollbar-thumb {
  opacity: 0.3;
  border: 2px solid transparent;
  background-clip: padding-box;
  -webkit-border-radius: 7px;
  background-color: #979797;
  -webkit-box-shadow: inset -1px -1px 0px rgba(0, 0, 0, 0.05), inset 1px 1px 0px rgba(0, 0, 0, 0.05);
}
::-webkit-scrollbar-button {
  width: 0;
  height: 0;
  display: none;
}
::-webkit-scrollbar-corner {
    background-color: transparent;
}
::-webkit-scrollbar-track-piece
{
    background-color: transparent;
    -webkit-border-radius: 6px;
}
.selectedLabel {
  &:hover {
    @apply bg-brand-light relative text-white;
    &::after {
      z-index: 50;
      content: '';
      display: block;
      position: absolute;
      width: 20px;
      height: 20px;
      right: 10px;
      background: url('../../assets/SVG/tick_white.svg') no-repeat center center;
    }

   }
}
</style>
